// freshchat.service.ts
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class FreshchatService {

  initFreshChat() {
    window.fcWidget.init({
      token: environment.freshChatToken,
      host: environment.freshChatHost,
     widgetUuid: environment.freshChatWidgetUuid
    });
  }

  initialize(i: any, t: string) {
    if (i.getElementById(t)) {
      this.initFreshChat();
    } else {
      const e = i.createElement('script');
      e.id = t;
      e.async = true;
      e.src = environment.freshChatHost+'/js/widget.js';
      e.onload = () =>  this.initFreshChat();
      i.head.appendChild(e);
    }
  }

  initiateCall() {
    this.initialize(document, 'freshchat-js-sdk');
  }
}
